// extracted by css-extract-rspack-plugin
export default {"selectField":"customer-communication-fragment__Select_selectField__Ku-25"};